export default {
  GET_CURRENT_JOB: (state) => {
    return state.currentJob;
  },
  GET_JOB_PROGRESS_TASKS: (state) => {
    return state.jobProgressTasks;
  },
};
